/**
 * Helpers for the canonical compact game-state format.
 *
 * Canonical `serialize()` output is separator-free: each entry is fixed-length and
 * entries are concatenated. `deserialize()` stays tolerant — it accepts the compact
 * form AND human-readable separated forms (commas, and dashes as in Knight's
 * "H4-I6"), so tests and tooling can write either. Canonicalizing is just stripping
 * the separators and re-chunking.
 */

/** Remove entry separators (',' and '-'), yielding the compact form. */
export function stripSeparators(serialized: string): string {
    return serialized.replace(/[,\-]/g, '');
}

/**
 * Split a compact-or-separated state into fixed-length entries of `entryLen`.
 * Trailing leftover shorter than `entryLen` is ignored.
 */
export function splitEntries(serialized: string, entryLen: number): string[] {
    const compact = stripSeparators(serialized);
    const entries: string[] = [];
    for (let i = 0; i + entryLen <= compact.length; i += entryLen) {
        entries.push(compact.slice(i, i + entryLen));
    }
    return entries;
}
